import React, { Fragment, useState, useRef } from 'react';
import { Container, Row, Col, FormGroup, Label, Input, Button, Spinner } from "reactstrap";
import { Breadcrumbs } from '../../AbstractElements';
import apiRequest from '../../utils/apiRequest';
import { useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';

const UploadTutorials = () => {
    const history = useNavigate();

    const token = useSelector((state) => state.auth.userToken);

    const [formData, setFormData] = useState({
        video: null,
    });
    const [loading, setLoading] = useState(false);

    const fileInputRef = useRef(null);

    const handleFileChange = (e) => {
        setFormData({
            ...formData,
            video: e.target.files[0],
        });
    };

    const handleUpload = async () => {
        if (!formData.video) {
            alert("Please select a video file to upload.");
            return;
        }

        const data = new FormData();
        data.append('media', formData.video);

        setLoading(true);
        try {
            await apiRequest('post', `${process.env.REACT_APP_API_BASE_URL}/admin/videos`, data, token, {
                'Content-Type': 'multipart/form-data'
            });
            setFormData({ video: null });
            fileInputRef.current.value = '';
            history("/dashboard") // Reset the file input field
        } catch (error) {
            console.error("Error uploading file:", error);
            alert("Error uploading file. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Fragment>
            <Breadcrumbs mainTitle="Tutorials" parent="Dashboard" title="All Tutorials" />
            <Container fluid={true}>
                <Row>
                    <FormGroup>
                        <Col sm="12">
                            <Label for="video">Tutorial Video</Label>
                            <Input
                                type="file"
                                id="video"
                                accept="video/*"
                                onChange={handleFileChange}
                                ref={fileInputRef} // Use ref to access the DOM element
                            />
                        </Col>
                    </FormGroup>
                    <Col sm="12">
                        <Button color="primary" onClick={handleUpload} disabled={loading}>
                            {loading ? <Spinner size="sm" /> : "Upload Video"}
                        </Button>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default UploadTutorials;
